// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file shopify/v1/shipping_rates.proto (package shopify.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Extensions, PageInfo, UserError } from './graphql_pb';
import { file_shopify_v1_graphql } from './graphql_pb';
import type { PresentmentMoneyDouble } from './presentment_money_double_pb';
import { file_shopify_v1_presentment_money_double } from './presentment_money_double_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file shopify/v1/shipping_rates.proto.
 */
export const file_shopify_v1_shipping_rates: GenFile =
    /*@__PURE__*/
    fileDesc(
        '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',
        [file_shopify_v1_graphql, file_shopify_v1_presentment_money_double]
    );

/**
 * ShippingRatesRequest carries the GraphQL variables of the market shipping
 * rates query. Every option definition type is asked for in one document, via
 * an inline fragment per RateType, so the caller no longer selects one.
 *
 * @generated from message shopify.v1.ShippingRatesRequest
 */
export type ShippingRatesRequest = Message<'shopify.v1.ShippingRatesRequest'> & {
    /**
     * @generated from field: string market_id = 1;
     */
    marketId: string;

    /**
     * after is the endCursor of the previously fetched option definition page.
     * Optional on purpose: an empty string is not a valid Shopify cursor, and the
     * variables are marshalled with EmitDefaultValues, which would send
     * "after": "" for the first page of a plain string field.
     *
     * @generated from field: optional string after = 2;
     */
    after?: string | undefined;
};

/**
 * Describes the message shopify.v1.ShippingRatesRequest.
 * Use `create(ShippingRatesRequestSchema)` to create a new message.
 */
export const ShippingRatesRequestSchema: GenMessage<ShippingRatesRequest> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 0);

/**
 * ShippingRateDefinition is one delivery option definition of a market with
 * every rate underneath it. It replaces the previously flattened ShippingRates
 * message: the type and the currency belong to the definition, the transit
 * times, the bounds and the price belong to each rate.
 *
 * @generated from message shopify.v1.ShippingRateDefinition
 */
export type ShippingRateDefinition = Message<'shopify.v1.ShippingRateDefinition'> & {
    /**
     * The GID of the option definition, e.g.
     * gid://shopify/DeliveryFlatRateOptionDefinition/123.
     *
     * @generated from field: string id = 1;
     */
    id: string;

    /**
     * The option definition name, which the merchant sees as the rate name. It
     * repeats across the rates of a rate group, which is why it lives here.
     *
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: shopify.v1.RateType type = 3;
     */
    type: RateType;

    /**
     * The currency every price and every money bound of the rates is given in,
     * e.g. "HUF". Empty when neither a rate of the definition nor its free
     * shipping threshold carries money.
     *
     * @generated from field: string currency = 4;
     */
    currency: string;

    /**
     * @generated from field: repeated shopify.v1.ShippingRateDefinitionRate rates = 5;
     */
    rates: ShippingRateDefinitionRate[];

    /**
     * free_from is the cart subtotal the option becomes free delivery from,
     * Shopify's freeDeliveryMinimumValue, in the definition currency. Optional
     * because a definition with no free shipping threshold has none, which is not
     * the same as a threshold of zero — that one is free from the first order.
     * It belongs to the definition rather than to a rate, like the name does.
     *
     * @generated from field: optional double free_from = 6;
     */
    freeFrom?: number | undefined;
};

/**
 * Describes the message shopify.v1.ShippingRateDefinition.
 * Use `create(ShippingRateDefinitionSchema)` to create a new message.
 */
export const ShippingRateDefinitionSchema: GenMessage<ShippingRateDefinition> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 1);

/**
 * ShippingRateDefinitionRate is one rate of an option definition.
 *
 * minimum and maximum are the bounds the rate applies between: money for
 * RATE_TYPE_ORDER_AMOUNT, weight in the shop weight unit for
 * RATE_TYPE_PACKAGE_WEIGHT, and unset for RATE_TYPE_FLAT. All three are
 * optional because Shopify leaves an open-ended bound, a missing transit
 * estimate and a rate without a price unset rather than zero.
 *
 * @generated from message shopify.v1.ShippingRateDefinitionRate
 */
export type ShippingRateDefinitionRate = Message<'shopify.v1.ShippingRateDefinitionRate'> & {
    /**
     * The GID of the rate, e.g. gid://shopify/DeliveryFlatRate/123. Unique per
     * returned entry.
     *
     * @generated from field: string id = 1;
     */
    id: string;

    /**
     * transitTimeMinSeconds
     *
     * @generated from field: int64 minimum_transit = 2;
     */
    minimumTransit: bigint;

    /**
     * transitTimeMaxSeconds
     *
     * @generated from field: int64 maximum_transit = 3;
     */
    maximumTransit: bigint;

    /**
     * @generated from field: optional double minimum = 4;
     */
    minimum?: number | undefined;

    /**
     * @generated from field: optional double maximum = 5;
     */
    maximum?: number | undefined;

    /**
     * @generated from field: optional double price = 6;
     */
    price?: number | undefined;
};

/**
 * Describes the message shopify.v1.ShippingRateDefinitionRate.
 * Use `create(ShippingRateDefinitionRateSchema)` to create a new message.
 */
export const ShippingRateDefinitionRateSchema: GenMessage<ShippingRateDefinitionRate> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 2);

/**
 * @generated from message shopify.v1.ShippingRatesResponse
 */
export type ShippingRatesResponse = Message<'shopify.v1.ShippingRatesResponse'> & {
    /**
     * @generated from field: shopify.v1.ShippingRatesQueryResponse data = 1;
     */
    data?: ShippingRatesQueryResponse | undefined;

    /**
     * @generated from field: shopify.v1.Extensions extensions = 2;
     */
    extensions?: Extensions | undefined;

    /**
     * @generated from field: repeated shopify.v1.UserError errors = 3;
     */
    errors: UserError[];
};

/**
 * Describes the message shopify.v1.ShippingRatesResponse.
 * Use `create(ShippingRatesResponseSchema)` to create a new message.
 */
export const ShippingRatesResponseSchema: GenMessage<ShippingRatesResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 3);

/**
 * @generated from message shopify.v1.ShippingRatesQueryResponse
 */
export type ShippingRatesQueryResponse = Message<'shopify.v1.ShippingRatesQueryResponse'> & {
    /**
     * @generated from field: shopify.v1.Market market = 1;
     */
    market?: Market | undefined;
};

/**
 * Describes the message shopify.v1.ShippingRatesQueryResponse.
 * Use `create(ShippingRatesQueryResponseSchema)` to create a new message.
 */
export const ShippingRatesQueryResponseSchema: GenMessage<ShippingRatesQueryResponse> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 4);

/**
 * @generated from message shopify.v1.Market
 */
export type Market = Message<'shopify.v1.Market'> & {
    /**
     * @generated from field: shopify.v1.MarketDelivery delivery = 1;
     */
    delivery?: MarketDelivery | undefined;
};

/**
 * Describes the message shopify.v1.Market.
 * Use `create(MarketSchema)` to create a new message.
 */
export const MarketSchema: GenMessage<Market> = /*@__PURE__*/ messageDesc(file_shopify_v1_shipping_rates, 5);

/**
 * @generated from message shopify.v1.MarketDelivery
 */
export type MarketDelivery = Message<'shopify.v1.MarketDelivery'> & {
    /**
     * @generated from field: shopify.v1.MarketShipping shipping = 1;
     */
    shipping?: MarketShipping | undefined;
};

/**
 * Describes the message shopify.v1.MarketDelivery.
 * Use `create(MarketDeliverySchema)` to create a new message.
 */
export const MarketDeliverySchema: GenMessage<MarketDelivery> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 6);

/**
 * @generated from message shopify.v1.MarketShipping
 */
export type MarketShipping = Message<'shopify.v1.MarketShipping'> & {
    /**
     * @generated from field: bool is_enabled = 1;
     */
    isEnabled: boolean;

    /**
     * @generated from field: shopify.v1.OptionDefinitionConnection option_definitions = 2;
     */
    optionDefinitions?: OptionDefinitionConnection | undefined;
};

/**
 * Describes the message shopify.v1.MarketShipping.
 * Use `create(MarketShippingSchema)` to create a new message.
 */
export const MarketShippingSchema: GenMessage<MarketShipping> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 7);

/**
 * @generated from message shopify.v1.OptionDefinitionConnection
 */
export type OptionDefinitionConnection = Message<'shopify.v1.OptionDefinitionConnection'> & {
    /**
     * @generated from field: repeated shopify.v1.OptionDefinitionNode nodes = 1;
     */
    nodes: OptionDefinitionNode[];

    /**
     * @generated from field: optional shopify.v1.PageInfo page_info = 2;
     */
    pageInfo?: PageInfo | undefined;
};

/**
 * Describes the message shopify.v1.OptionDefinitionConnection.
 * Use `create(OptionDefinitionConnectionSchema)` to create a new message.
 */
export const OptionDefinitionConnectionSchema: GenMessage<OptionDefinitionConnection> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 8);

/**
 * @generated from message shopify.v1.OptionDefinitionNode
 */
export type OptionDefinitionNode = Message<'shopify.v1.OptionDefinitionNode'> & {
    /**
     * @generated from field: string type_name = 1 [json_name = "__typename"];
     */
    typeName: string;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: shopify.v1.RateGroupConnection rate_groups = 3;
     */
    rateGroups?: RateGroupConnection | undefined;

    /**
     * The GID of the option definition, selected inside every fragment because
     * the connection nodes are typed as the interface.
     *
     * @generated from field: string id = 4;
     */
    id: string;

    /**
     * freeDeliveryMinimumValue, the cart subtotal the option is free delivery
     * from. Null on a definition with no free shipping threshold.
     *
     * @generated from field: optional shopify.v1.PresentmentMoneyDouble free_delivery_minimum_value = 5;
     */
    freeDeliveryMinimumValue?: PresentmentMoneyDouble | undefined;
};

/**
 * Describes the message shopify.v1.OptionDefinitionNode.
 * Use `create(OptionDefinitionNodeSchema)` to create a new message.
 */
export const OptionDefinitionNodeSchema: GenMessage<OptionDefinitionNode> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 9);

/**
 * @generated from message shopify.v1.RateGroupConnection
 */
export type RateGroupConnection = Message<'shopify.v1.RateGroupConnection'> & {
    /**
     * @generated from field: repeated shopify.v1.RateGroupNode nodes = 1;
     */
    nodes: RateGroupNode[];

    /**
     * @generated from field: optional shopify.v1.PageInfo page_info = 2;
     */
    pageInfo?: PageInfo | undefined;
};

/**
 * Describes the message shopify.v1.RateGroupConnection.
 * Use `create(RateGroupConnectionSchema)` to create a new message.
 */
export const RateGroupConnectionSchema: GenMessage<RateGroupConnection> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 10);

/**
 * RateGroupNode holds a single rate for DeliveryFlatRateOptionDefinition and a
 * rate connection for the value and weight based definitions. Only one of the
 * two is populated, depending on which fragment was queried.
 *
 * @generated from message shopify.v1.RateGroupNode
 */
export type RateGroupNode = Message<'shopify.v1.RateGroupNode'> & {
    /**
     * @generated from field: shopify.v1.Rate rate = 1;
     */
    rate?: Rate | undefined;

    /**
     * @generated from field: shopify.v1.RateConnection rates = 2;
     */
    rates?: RateConnection | undefined;
};

/**
 * Describes the message shopify.v1.RateGroupNode.
 * Use `create(RateGroupNodeSchema)` to create a new message.
 */
export const RateGroupNodeSchema: GenMessage<RateGroupNode> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 11);

/**
 * @generated from message shopify.v1.RateConnection
 */
export type RateConnection = Message<'shopify.v1.RateConnection'> & {
    /**
     * @generated from field: repeated shopify.v1.Rate nodes = 1;
     */
    nodes: Rate[];

    /**
     * @generated from field: optional shopify.v1.PageInfo page_info = 2;
     */
    pageInfo?: PageInfo | undefined;
};

/**
 * Describes the message shopify.v1.RateConnection.
 * Use `create(RateConnectionSchema)` to create a new message.
 */
export const RateConnectionSchema: GenMessage<RateConnection> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 12);

/**
 * Rate is DeliveryFlatRate, DeliveryValueBasedRate or DeliveryWeightBasedRate,
 * depending on which fragment was queried. All three carry an id and a price
 * next to the transit times; only the value and weight based ones carry the
 * criteria bounds.
 *
 * @generated from message shopify.v1.Rate
 */
export type Rate = Message<'shopify.v1.Rate'> & {
    /**
     * @generated from field: int64 transit_time_min_seconds = 1;
     */
    transitTimeMinSeconds: bigint;

    /**
     * @generated from field: int64 transit_time_max_seconds = 2;
     */
    transitTimeMaxSeconds: bigint;

    /**
     * @generated from field: string id = 3;
     */
    id: string;

    /**
     * @generated from field: optional shopify.v1.PresentmentMoneyDouble price = 4;
     */
    price?: PresentmentMoneyDouble | undefined;

    /**
     * @generated from field: optional shopify.v1.RateCriteria criteria_minimum = 5;
     */
    criteriaMinimum?: RateCriteria | undefined;

    /**
     * @generated from field: optional shopify.v1.RateCriteria criteria_maximum = 6;
     */
    criteriaMaximum?: RateCriteria | undefined;
};

/**
 * Describes the message shopify.v1.Rate.
 * Use `create(RateSchema)` to create a new message.
 */
export const RateSchema: GenMessage<Rate> = /*@__PURE__*/ messageDesc(file_shopify_v1_shipping_rates, 13);

/**
 * RateCriteria is one bound of a value or weight based rate.
 *
 * The query selects the fields of the union member inline
 * (... on MoneyV2 / ... on Weight), so both shapes arrive flattened onto the
 * same object rather than nested: amount and currency_code for a value based
 * rate, value and unit for a weight based one. type_name says which of the two
 * was returned.
 *
 * @generated from message shopify.v1.RateCriteria
 */
export type RateCriteria = Message<'shopify.v1.RateCriteria'> & {
    /**
     * @generated from field: string type_name = 1 [json_name = "__typename"];
     */
    typeName: string;

    /**
     * @generated from field: optional double amount = 2;
     */
    amount?: number | undefined;

    /**
     * @generated from field: string currency_code = 3;
     */
    currencyCode: string;

    /**
     * @generated from field: optional double value = 4;
     */
    value?: number | undefined;

    /**
     * The weight unit as Shopify spells it, e.g. "KILOGRAMS". Kept as a string
     * rather than the WeightUnit enum, whose JSON names are prefixed and would be
     * silently discarded on unmarshal.
     *
     * @generated from field: string unit = 5;
     */
    unit: string;
};

/**
 * Describes the message shopify.v1.RateCriteria.
 * Use `create(RateCriteriaSchema)` to create a new message.
 */
export const RateCriteriaSchema: GenMessage<RateCriteria> =
    /*@__PURE__*/
    messageDesc(file_shopify_v1_shipping_rates, 14);

/**
 * RateType selects which DeliveryOptionDefinition implementation is queried.
 *
 * @generated from enum shopify.v1.RateType
 */
export enum RateType {
    /**
     * @generated from enum value: RATE_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,

    /**
     * DeliveryFlatRateOptionDefinition
     *
     * @generated from enum value: RATE_TYPE_FLAT = 1;
     */
    FLAT = 1,

    /**
     * DeliveryValueBasedOptionDefinition
     *
     * @generated from enum value: RATE_TYPE_ORDER_AMOUNT = 2;
     */
    ORDER_AMOUNT = 2,

    /**
     * DeliveryWeightBasedOptionDefinition
     *
     * @generated from enum value: RATE_TYPE_PACKAGE_WEIGHT = 3;
     */
    PACKAGE_WEIGHT = 3,
}

/**
 * Describes the enum shopify.v1.RateType.
 */
export const RateTypeSchema: GenEnum<RateType> = /*@__PURE__*/ enumDesc(file_shopify_v1_shipping_rates, 0);
